import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const LeadFormContext = createContext(null);

export function LeadFormProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname, hash } = useLocation();
  const navigate = useNavigate();

  const openLeadForm = useCallback(() => setIsOpen(true), []);
  const closeLeadForm = useCallback(() => setIsOpen(false), []);

  useEffect(() => {
    if (hash === '#quote') {
      setIsOpen(true);
      navigate(pathname, { replace: true });
    }
  }, [hash, pathname, navigate]);

  useEffect(() => {
    document.body.classList.toggle('lead-form-open', isOpen);
    return () => document.body.classList.remove('lead-form-open');
  }, [isOpen]);

  const value = useMemo(
    () => ({ isOpen, openLeadForm, closeLeadForm }),
    [isOpen, openLeadForm, closeLeadForm],
  );

  return <LeadFormContext.Provider value={value}>{children}</LeadFormContext.Provider>;
}

export function useLeadForm() {
  const context = useContext(LeadFormContext);
  if (!context) {
    throw new Error('useLeadForm must be used within LeadFormProvider');
  }
  return context;
}
